import React from "react"
import styled from "styled-components"

export default function TextAnimation() {
  return <Word>React</Word>
}

const Word = styled.span`
  display: inline-block;
  background: linear-gradient(180deg, #FFD7FF 0%, #FFB6FF 100%);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
`
